<template>
    <div> 
      <div v-if="btn">

        <button v-if="messages.length > 0" @click ="showMessages('message')" type="button" class="btn btn-warning mr-3">
          TRASFERIMENTO <span class="badge badge-primary ml-2">{{ messages.length  }}</span>
        </button>
        <button v-if="booking.length > 0" @click ="showMessages('booking')" type="button" class="btn btn-warning mr-3 ">
          RICHIESTA TRASFERIMENTO <span class="badge badge-primary ml-2">{{ booking.length  }}</span>
        </button>
        
      </div>
      <div v-else>
        <div class="modal" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content border-warning">
        <div class="modal-header bg-info">
          <h5 class="modal-title" id="staticBackdropLabel">
            <i style="color:black" class="fas fa-bell mr-3"></i>
            NOTIFICA DI {{ typeId ? 'TRASFERIMENTO' : 'RICHIESTA DI TRASFERIMENTO' }}</h5>            
        </div>
        <div class="modal-body">         
          <div v-if="typeId">
            <messageTable v-bind:messages="messages"></messageTable>            
          </div>
          <div v-else>           
            <bookingTable v-bind:booking="booking"></bookingTable>            
          </div>         
        </div>
        <div class="modal-footer">                    
          <div class="form-check " >
            <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="notRead">
              <label class="form-check-label" for="defaultCheck1">
                Segna come da leggere.
              </label>
          </div>                  
            <button  @click="setData(typeId)" type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>                            
        </div>
        </div>
        </div>
      </div>  
      </div>        
    </div>
  </template>

  <script>
  
 import { mapGetters }      from 'vuex'
 import api                 from '@/api'
 import bookingTable        from '@/components/sse/BookingTable.vue'
 import messageTable        from '@/components/sse/MessageTable.vue'
   export default {
    components: {bookingTable,messageTable},
    data() {
      return {
        messages : [],
        booking  : [],
        
        msg      : '',  
        btn      : true,
        typeId   : true,
        notRead  : true
      };
    },
    computed: 
    {
        ...mapGetters(['storeId']) , 
    },  
    mounted()  {
            
    },
    beforeDestroy() {


        this.msg.close();
        //console.log('CLOSE CONNECTION')
      // Make sure to close the connection with the events server
      // when the component is destroyed, or we'll have ghost connections!
      
    },
    created() 
    {
        
        const url  =  process.env.VUE_APP_ROOT_API1 + "api/sse/events/" + this.storeId
        this.msg   = new EventSource(url)
        
        this.msg.onmessage = (event) =>
        {
        
            const arr1 = []
            const arr2 = []
            const data = JSON.parse(event.data)   

            if(Array.isArray(data))
            {
              let index = 0
              data.forEach(item => {
         
                if(item.typeId == 'booking')
                {
                  item.index = index
                  arr1.push(item)
                  index++
                  
                }
                else
                {
                  item.index = index
                  arr2.push(item)    
                  index++
                }
                                         
              })
              this.booking = arr1
              this.messages = arr2
             
            }
            else
            {
              /*
              if(data.shippedTo == this.storeId )
              {
                */
               
                if(data.typeId == 'booking')
                {
                  data.index = this.booking.length > 0 ? this.booking.length + 1 : 0
                  
                  this.booking.push(data)

                }
                else
                {
                  data.index = this.messages.length > 0 ? this.messages.length + 1 : 0
                  this.messages.push(data)    
                }
                
              //}
            }
            
           
            this.messages.sort((a, b) => b.index - a.index) 
            this.booking.sort((a, b) => b.index - a.index) 
                        
        }                
   this.msg.onerror = function(event) {
       //console.log("SSE onerror " + event);
   }
   this.msg.onopen = function() {

       //console.log("SSE onopen");
   }
    
   
    },
    
    methods:{
      setData(typeId)
      {

        if(this.notRead)
        {
          this.btn = true
          return
        }
        const data = []
        if(typeId)
        {
          this.messages.forEach(item => {
            data.push({'rowId':item.rowId})
          })
          this.messages = []  
        }
        else
        {
          this.booking.forEach(item => {
            data.push({'rowId' : item.rowId})
          })
          this.booking = []
        }
        
        
        api.deleteMsg(data)
        this.btn = true
        console.log('DELETE')  
      },
      showMessages(typeId)
      {
        this.btn      = false
        this.notRead  = true
        this.typeId   = (typeId == 'message') ? true : false
        this.$nextTick(()  => {                  
            $('#staticBackdrop').modal('show')
          })  
        
      }
    }
  }

  </script>
  <style scoped>

  
 td{
  color       : black;
  
 } 
 h4 {
    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 20px;
  }
 
  li {

    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 14px;
    font-weight : bold;

  }
 
  label {
    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 20px;
    cursor      : pointer;
  }

  .modal-footer {  
    justify-content: space-between;  
  }


  </style>